import React, { useContext } from 'react';
import { Modal } from 'react-bootstrap';
import toast, {Toaster} from 'react-hot-toast';

import { DataContext } from '../../../init/getData';

const ScaleRecover = (props) => {

const { api, userData } = useContext(DataContext);

const { showModal, toggleModal, idRow, refreshTable, tittle } = props;

const {refreshCategory} = useContext(DataContext);


  const trigger = async () => {
    let data = {id: idRow.id}
    let res = await api.post(`scale/recover`, JSON.stringify(data));
    if(res.data.status){
      toast.success(res.data.message);
    }else{
      toast.error(res.data.message);
    }
        
    refreshCategory();
    toggleModal();
    refreshTable();
  }
  

    
  return (
    <Modal show={showModal} onHide={toggleModal} className='Delete_modal'>
      <Modal.Header style={{ background: "#1f2937" }}>
        <Modal.Title style={{ color: "white" }}>Recover {tittle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      {tittle} Will be Recovered ,
      are you sure ?
      
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={toggleModal}>NO</button>
        <input type="button" className="btn btn-primary" onClick={trigger} value="Yes !!"></input>
      </Modal.Footer>
    </Modal>
  );

  }
export default ScaleRecover;
